module.exports = "../images/boats-2.jpg?v=888ae2d";